import { Field } from '@/types';
import { Rule } from '@/types';

interface DateOptions {
	menu: {
		zIndex: number;
	};
	textField: {
		clearable: boolean;
		label: string;
		validateOnBlur: boolean;
		outlined: boolean;
		rulesNames: Rule[];
		rules: any;
	};
	datePicker: {
		max: string;
	};
}
/** service for mapping options from api with options needed  */
const datePickerOptionsFactory = {
	/** get the options defined form the datepicker using the data from api */
	getOptions(field: Field) {
		const dateOptions = {
			menu: {
				zIndex: 203
			},
			textField: {
				clearable: true,
				label: field.label,
				validateOnBlur: true,
				outlined: true,
				rulesNames: [] as Rule[],
				...field.options
			}
		} as DateOptions;

		return this.getRules(dateOptions, field.rules as Rule[]);
	},
	getRules(dateOptions: DateOptions, rules: Rule[]) {
		for (const rule of rules) {
			switch (rule.name) {
			case 'notAfterToday': {
				dateOptions.textField.rulesNames.push({
					name: 'notAfterToday'
				});

				dateOptions.datePicker = {
					...dateOptions.datePicker,
					max: new Date().toISOString()
				};

				break;
			}
			case 'dateRange': {
				dateOptions.textField.rulesNames.push({
					name: rule.name,
					args: rule.args
				});

				break;
			}
			case 'requiredFn':
			case 'required': {
				dateOptions.textField.rulesNames.push({
					name: 'requiredFn'
				});

				break;
			}
			}
		}

		return dateOptions;
	}
};

export default datePickerOptionsFactory;
